<script setup lang="ts">
import { watchDebounced } from '@vueuse/core';
import { onMounted } from 'vue';

import { AlgoliaVariant } from '@/api/algolia';
import { MerchandisingBannerSyntheticHit } from '@/components/search/products/BannerCard.vue';
import { Taggstar } from '@/utils/analytics/taggstar';

const props = defineProps<{ items: (AlgoliaVariant | MerchandisingBannerSyntheticHit)[] }>();

onMounted(() => {
  watchDebounced(
    () => props.items,
    (items) => {
      if (items.length === 0) return;
      const variants = items.filter((item) => 'Product' in item);
      if (variants.length === 0) return;

      Taggstar.categoryVisit({
        items: variants.map((variant) => ({
          id: variant.Product.key,
          oos: variant.outOfStock,
        })),
      });
    },
    { debounce: 1000, immediate: true },
  );
});
</script>

<template>
  <div>
    <div
      v-for="(item, index) in items"
      :key="item.objectID"
      class="py-5 border-b border-solid border-neutral-200 ws-md:px-5 -mb-[1px]"
      :class="index % 2 === 0 ? 'pr-3' : 'pl-3'"
      itemprop="itemListElement"
      itemscope
      itemtype="http://schema.org/ListItem"
    >
      <slot :item />
    </div>
  </div>
</template>
